import { createContext, useContext } from "react";

/**
 * Interface for Cyclone comment counts service (Honeypot bulk API).
 */
export interface CycloneService {
  getCommentCount: (countKey: string) => number | null;
  updateCommentCount: (
    countKey: string,
    count: number,
    timestamp: number,
  ) => void;
  subscribeToCommentCount: (
    countKey: string,
    callback: (count: number) => void,
  ) => () => void;
  registerCountId: (countKey: string) => void;
  loadAllCountsFromIndexedDB: () => Promise<void>;
  getLastReadCount: (countKey: string) => Promise<number | null>;
  setLastReadCount: (countKey: string, count: number) => Promise<void>;
}

const CycloneCommentsContext = createContext<CycloneService | null>(null);

/**
 * Hook to access the Cyclone comment counts service.
 * @throws Error if used outside of a Cyclone counts provider
 */
export const useCycloneCommentsContext = (): CycloneService => {
  const context = useContext(CycloneCommentsContext);

  if (!context) {
    throw new Error(
      "useCycloneCommentsContext must be used within a Cyclone counts provider",
    );
  }

  return context;
};

export default CycloneCommentsContext;
